import { useMutation, useQueryClient } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { whatsappKeys } from "@/lib/query-keys";

export function useOptOutWhatsapp() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () =>
      fetchToBackend("/userextrainformation/whatsapp/optout", {
        method: "POST",
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: whatsappKeys.status }),
  });
}
